import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import ReceivementCard from '../../../../components/ReceivementCard'
import { useReceivement } from '../../../../hooks/useReceivement'
import {
  sendReceivementToManagerCheck,
} from '../../../../services/receivement/receivementService'
import { ReceivementOverviewTable } from '../../components/ReceivementTables'
import * as S from './ReceivementOverview.styles'
import * as selectors from '../../ReceivementSelectors'
import { ReceivementOverviewFilters } from '../../components/ReceivementOverviewFilters'
import { ReceivementHeader } from '../../components/ReceivementHeader'
import { ReceivementInfo } from '../../components/ReceivementInfo'
import { actions } from '../../ReceivementState'
import TagPrinterManagerPerBlock from 'src/components/TagPrinterManagerPerBlock/TagPrinterManagerPerBlock'
import { ReceivementShelfTag } from 'src/components/Tags/ReceivementShelfTag'
import { GetBatches } from '../../ReceivementTypes'
import { formatDate } from 'src/utils/formatDate'

const ReceivementOverview = () => {
  const [showingModal, setShowingModal] = useState(false)
  const [fetching, setFetching] = useState(false)
  const [clickPrint, setClickPrint] = useState(false)
  const { receivementId } = useParams<{ receivementId?: string }>()
  const overview = useSelector(selectors.selectOverview)
  const batches = useSelector(selectors.selectBatches)
  const directGondolaPrintLimit = useSelector(selectors.selectDirectGondolaPrintLimit)
  const dispatch = useDispatch()

  const history = useHistory()
  const { operatorBadge, supervisorBadge } = useReceivement({
    valideOperator: true,
  })

  const badge = supervisorBadge || operatorBadge

  React.useEffect(() => {
    dispatch(actions.clear())
  }, [dispatch])

  const handleSendToManagerCheck = React.useCallback(async () => {
    setFetching(true)
    const result = await sendReceivementToManagerCheck(badge, receivementId)
    if (result.isOk) {
      toast.success('Enviado para conferência!')
      history.push(`/receivement/${receivementId}/finish`)
    } else {
      toast.error(result?.data?.message || 'Falha ao enviar para a conferência!')
    }
    setFetching(false)
  }, [badge, history, receivementId])

  const filterDirectShelf = batches?.filter((b) => b.diretoGondola === true && !b.printedDirectGondola)

  const formatBatchList = filterDirectShelf?.map((b) => (
    {
      entryDateAndHour: formatDate(b.dataInclusao),
      batchId: b.idLote,
      modelShopper: b.idModelo,
      barcode: b.codigoDeBarrasUtilizado,
      description: b.descricao,
      fc: b.fc.name,
      productCode: b.codProduto,
      batchNumber: b.batchNumber,
      isDirectShelf: b.diretoGondola,
      addressTag: b.addressTag?.enderecoGenerated,
    }))

  const tags = formatBatchList?.map((b) => <ReceivementShelfTag obj={{ ...b, printed: false }} />)

  useEffect(() => {
    const payload: GetBatches = {
      receivementId: Number(receivementId),
      badge,
    }
    dispatch(actions.getReceivementBatches(payload))
  }, [dispatch, receivementId, badge])

  const headerButton = React.useMemo(() => (
    <S.ButtonWrapper>
      <S.Button onClick={() => setShowingModal(true)} disabled={fetching || !filterDirectShelf.length}>
        Imprimir direto gôndola
      </S.Button>
      <S.Button onClick={handleSendToManagerCheck} disabled={fetching || (filterDirectShelf.length > 0 && clickPrint === false)}>
        Finalizar
      </S.Button>
    </S.ButtonWrapper>
  ),
  [fetching, filterDirectShelf.length, handleSendToManagerCheck, clickPrint])

  return (
    <S.Container>
      <ReceivementHeader
        title={(
          <S.SubTitle>
            Resumo do Recebimento{' '}
            <S.SubTitleExtension>- ARs e Lotes</S.SubTitleExtension>
          </S.SubTitle>
        )}
        headerButton={headerButton}
      />
      <ReceivementInfo
        operator={overview?.operator}
        supervisor={overview?.supervisor}
        dock={overview?.dock}
        supplier={overview?.supplier}
        receivementId={receivementId}
      />
      <ReceivementOverviewFilters
        badge={badge}
      />
      {overview?.products?.map((product, index) => (
        <ReceivementCard
          key={`${product.productCode}-${index}`}
          product={product}
          BatchesTable={ReceivementOverviewTable}
        />
      ))}
      <TagPrinterManagerPerBlock
        tagsToPrint={tags}
        showTagModal={showingModal}
        setShowTagModal={setShowingModal}
        modalTitle='Impressão de etiquetas direto gôndola'
        printLimit={directGondolaPrintLimit}
        setClickPrint={setClickPrint}
      />
    </S.Container>
  )
}

export default ReceivementOverview
